var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"banner",class:_vm.use},[_c('div',{staticClass:"info container"},[_vm._t("info-content")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }